export default "__VITE_ASSET__46d97935__"